import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { usePage } from 'client/store'
import { getReadableRootEntity } from 'client/store/page/pageSelectors'
import { BaseEntityBodyInterface } from 'common/types/entities/EntityInterface'
import { getMobileBackgroundFileId } from 'common/utils/getMobileBackgroundFileId'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { ImageControl } from 'src/editor/shared/settings/controls/image-control'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'
import { useUpdateProp } from '../../hooks/useUpdateProps'

export const Background = <T extends BaseEntityBodyInterface>() => {
  const { isMobile } = useDeviceModeContext()
  const entity = usePage(getReadableRootEntity) as T

  const updateProp = useUpdateProp<T>(entity)

  const getBackgroundPosition = () =>
    isMobile
      ? (entity.mobileBackground ?? entity.background)
      : entity.background

  const getFileId = () =>
    isMobile
      ? getMobileBackgroundFileId(
          entity.backgroundFileId,
          entity.mobileBackgroundFileId,
        )
      : entity.backgroundFileId

  return (
    <>
      <GroupTitle>page_settings.body.background.group_title</GroupTitle>
      <ColorPickerControl
        label="settings_styles.background_color.label"
        update={updateProp('backgroundColor')}
        mobileUpdate={updateProp('mobileBackgroundColor')}
        color={entity.backgroundColor}
        mobileColor={entity.mobileBackgroundColor}
        isClearable
      />

      <ImageControl
        isMobile={isMobile}
        backgroundPosition={getBackgroundPosition()}
        fileId={getFileId()}
        updateBackgroundFileId={updateProp(
          isMobile ? 'mobileBackgroundFileId' : 'backgroundFileId',
        )}
        update={updateProp(isMobile ? 'mobileBackground' : 'background')}
      />
      <RangeElement
        label="page_settings.body.background_blur.label"
        value={entity.blur}
        onChange={updateProp('blur')}
        max={10}
      />
    </>
  )
}
